<template>
    <a-tabs type="line">
        <a-tab-pane 
            key="1" 
            tab="Información"
        >
            <Information 
                :station="stationInf" 
                :hoja-vida="pathPdf"
                :aforo="pathAforo"
            />
        </a-tab-pane>

        <a-tab-pane 
            key="2" 
            tab="Variables" 
            v-if="enableVariables"
        >
            <Variable 
                :station-inf="stationInf"
                :station-data="stationChart" 
                :index="index"
                :indicator-a3="indicatorA3"
                :indicator-a25="indicatorA25"
            />
        </a-tab-pane>

        <a-tab-pane 
            key="3" 
            tab="Galería" 
            v-if="pathImg1 != '' || pathImg2 != ''"
        >
            <Galery 
                :ruta1="pathImg1" 
                :ruta2="pathImg2" 
            />
        </a-tab-pane>
    </a-tabs>
</template>

<script>
    import Variable from './Tabs/Variable';
    import Information from './Tabs/Information';
    import Galery from './Tabs/Galery';
    import rutasJson from '@/assets/json/rutasEstaciones.json';
    import queries from '@/services/links_queries.js';

    export default {
        name: "Menu",

        components:{Information,
                    Variable,
                    Galery
        },

        props: {
            stationInf: [],
            stationChart: [],
            index: Number,
            indicatorA3: [],
            indicatorA25: []
        },

        computed:{
            enableVariables(){
                if(this.stationChart[0] == null){
                    return false;
                }else{
                    for(var i in this.stationChart){
                        if( this.stationChart[i].humidity != null 
                        || this.stationChart[i].precipitation != null
                        || this.stationChart[i].presure != null 
                        || this.stationChart[i].radiation != null
                        || this.stationChart[i].temperature != null 
                        || this.stationChart[i].windDirection != null){
                            return true;
                        }
                    }
                    
                    return false;
                }
            },

            /*
            * Las rutas son sacadas del archivo rutasEstaciones.json
            * En pathPdf se manda a información para mostrar la hoja de vida de la estación
            * En rutaImg1 y rutaImg2 se manda a galería las rutas de las imágenes de la estación
            */
            pathPdf(){
                let ruta = '';
                for(var i in rutasJson){
                    if(rutasJson[i].id == this.stationInf.idStation){
                        if(rutasJson[i].rutaPdf != null){
                            ruta = queries.galery_pdf+rutasJson[i].rutaPdf;
                        }else{
                            ruta = '';
                        }
                    }
                }
                return ruta;
            },

            pathImg1(){
                let ruta = '';
                for(var i in rutasJson){
                    if(rutasJson[i].id == this.stationInf.idStation){
                        if(rutasJson[i].ruta1 != null){
                            ruta = queries.galery_images+rutasJson[i].ruta1;
                        }else{
                            ruta = '';
                        }
                    }
                }
                return ruta;
            },

            pathImg2(){
                let ruta = '';
                for(var i in rutasJson){
                    if(rutasJson[i].id == this.stationInf.idStation){
                        if(rutasJson[i].ruta1 != null){
                            ruta = queries.galery_images+rutasJson[i].ruta2;
                        }else{
                            ruta = '';
                        }
                    }
                }
                return ruta;
            },

            pathAforo(){
                let aforo = false;
                for(var i in rutasJson){
                    if(rutasJson[i].id == this.stationInf.idStation){
                        aforo = rutasJson[i].aforo;
                    }
                }
                return aforo;
            }
        }
    };
</script>